var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkPlayBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 20.5,
    stroke: "#D8D8D8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 14.2294,
    fill: "#979797"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9814 21.552L19.2129 16.9581C19.1412 16.9096 19.0483 16.9046 18.9718 16.9438C18.895 16.9836 18.8469 17.0617 18.8469 17.1471V26.335C18.8469 26.4205 18.895 26.4988 18.9718 26.5385C19.0059 26.556 19.0432 26.5647 19.0803 26.5647C19.1268 26.5647 19.173 26.5509 19.2129 26.5241L25.9814 21.9301C26.0446 21.8871 26.0822 21.8166 26.0822 21.7411C26.0822 21.6655 26.0444 21.595 25.9814 21.552Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkPlayBtn);
export default __webpack_public_path__ + "static/media/dark-play-btn.4f1b03adb94687bacfea10bf66b3677b.svg";
export { ForwardRef as ReactComponent };